module.exports = __webpack_public_path__ + "static/media/team-06.33618a86.jpeg";